import { UserWithStatus } from '../types';

export const saveUserToStorage = async (user: UserWithStatus) => {
    const saved = localStorage.getItem('magnus_users');
    const users = saved ? JSON.parse(saved) : [];
    const index = users.findIndex((u: any) => u.username === user.username);
    if (index >= 0) users[index] = user;
    else users.push(user);
    localStorage.setItem('magnus_users', JSON.stringify(users));
};

export const deleteUserFromStorage = async (username: string) => {
    const saved = localStorage.getItem('magnus_users');
    if (!saved) return;
    let users = JSON.parse(saved);
    users = users.filter((u: any) => u.username !== username);
    localStorage.setItem('magnus_users', JSON.stringify(users));
};

export const getUsersFromStorage = (): UserWithStatus[] => {
    const saved = localStorage.getItem('magnus_users');
    return saved ? JSON.parse(saved) : [];
};
